// Generate code from clean architecture template

import { useEffect, useState } from 'react';
import { ConfigKeyEnum, SalesTargetRankingEntity } from '@/domains/config-system/entities';
import { ConfigSystemHttpRepository } from '../adapters/repositories';
import { FindByKeyConfigSystemUsecase } from '@/domains/config-system/usecases';
import { notification } from 'antd';
interface ConfigSystemHistoryItem {
  id: string;
  configSystemId: string;
  key: string;
  valueType: string;
  previousValue: string;
  newValue: string;
  action: string;
  createdAt: string;
  createdBy: string;
}

export default function FindByKeySalesTargetRankingViewModel() {
  const [data, setData] = useState<SalesTargetRankingEntity[]>([]);
  const [history, setHistory] = useState<ConfigSystemHistoryItem[]>();
  const [loading, setLoading] = useState<boolean>(false);

  const configSystemHttpRepository = new ConfigSystemHttpRepository();
  const findByKeyConfigSystemUsecase = new FindByKeyConfigSystemUsecase(configSystemHttpRepository);

  const actionFetchData = async () => {
    try {
      setLoading(true);
      const response = await findByKeyConfigSystemUsecase.run({
        key: ConfigKeyEnum.SALES_TARGET_RANKING_CONFIGURATION,
      });
      if (!response) {
        throw new Error('No data found');
      }

      setData(response.value ? JSON.parse(response.value) : []);
      setHistory(response?.configSystemHistories);

      notification.success({
        message: 'Fetch data successfully',
      });
    } catch (error) {
      console.log(error);
      notification.error({
        message: 'Fetch data failed',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      actionFetchData();
    }, 1000);
  }, []);

  return {
    data,
    history,
    loading,
    actionFetchData,
  };
}
